import { render, staticRenderFns } from "./DsfPracticeResult.vue?vue&type=template&id=20303780&"
import script from "./DsfPracticeResult.vue?vue&type=script&lang=js&"
export * from "./DsfPracticeResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20303780')) {
      api.createRecord('20303780', component.options)
    } else {
      api.reload('20303780', component.options)
    }
    module.hot.accept("./DsfPracticeResult.vue?vue&type=template&id=20303780&", function () {
      api.rerender('20303780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/views/DsfPracticeResult.vue"
export default component.exports